<template>
  <v-card flat class="px-16 pb-16 pt-8">
    <v-card-text class="primary--text text-center text-h5 mb-10">
      {{ message }}
    </v-card-text>
    <v-card-text class="d-flex justify-center primary--text text-center mb-10">
      <LoadingCard :size="100" />
    </v-card-text>
    <v-card-text class="text-center text-subtitle-2">
      We're getting things ready for you...
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import Vue from "vue";
import LoadingCard from "./LoadingCard.vue";
export default Vue.extend({
  name: "DescriptiveLoader",
  props: {
    message: {
      type: String,
      default: "Power Trip is loading",
    },
  },
  components: {
    LoadingCard,
  },
});
</script>
